import { render, staticRenderFns } from "./settings-organization-introductions.vue?vue&type=template&id=fc8bddfa&scoped=true&"
import script from "./settings-organization-introductions.vue?vue&type=script&lang=js&"
export * from "./settings-organization-introductions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8bddfa",
  null
  
)

export default component.exports